import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useSelector } from 'react-redux';
import { BankingRootStateConfigKeys } from '@americanexpress/blueprint-common/constants';

/* eslint-disable no-underscore-dangle */
export const useDatadog = () => {
  const env = useSelector((state) =>
    state.getIn(['config', BankingRootStateConfigKeys.LocaleFilename])
  );

  const datadogApplicationId = useSelector((state) =>
    state.getIn(['config', BankingRootStateConfigKeys.DatadogApplicationId])
  );

  const datadogClientId = useSelector((state) =>
    state.getIn(['config', BankingRootStateConfigKeys.DatadogClientId])
  );

  const isProduction = env !== 'integration' && env !== 'qa';

  useEffect(() => {
    if (
      window.__datadog_rum_initialized ||
      !datadogClientId ||
      !datadogApplicationId
    ) {
      window.ddEnv = env;
      window.ddClientIdCheck = !datadogClientId;
      window.ddAppIdCheck = !datadogApplicationId;
      return;
    }

    try {
      datadogRum.init({
        applicationId: datadogApplicationId,
        clientToken: datadogClientId,
        site: 'datadoghq.com',
        service: isProduction ? 'cfaas-app' : 'cfaas-app-playground',
        environment: isProduction ? 'production' : env,
        version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackResources: true,
        trackUserInteractions: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        beforeSend: (event) => {
          if (
            event.type === 'action' &&
            event.action.frustration?.type.includes('dead_click')
          ) {
            return false;
          }
          return true;
        },
      });
    } catch (error) {
      window.ddInitError = error;
      window.__datadog_rum_initialized = false;
    }

    const publicGuid = document?.cookie
      ?.split('blueboxpublic=')[1]
      ?.split(';')[0];

    datadogRum.setUser({ id: publicGuid });

    window.__datadog_rum_initialized = true;
  }, [env, isProduction, datadogClientId, datadogApplicationId]);
};
